export default {
  md: 1400,
  lg: 1920
}
